import Button from "@mui/material/Button"
import Dialog from "@mui/material/Dialog"
import DialogActions from "@mui/material/DialogActions"
import DialogContent from "@mui/material/DialogContent"
import DialogTitle from "@mui/material/DialogTitle"
import { SxProps } from "@mui/material/styles"
import React from "react"

interface IProps {
  open: boolean
  title: string
  onCancel: () => void
  onSubmit: () => void
  submitLabel: string
  disableButtons?: boolean
  children?: React.ReactNode
}

const sx: SxProps = {
  minWidth: 400,
}

export function ConfirmationDialog(props: IProps) {
  return (
    <Dialog onClose={props.onCancel} open={props.open}>
      <DialogTitle>{props.title}</DialogTitle>
      <DialogContent sx={sx}>{props.children}</DialogContent>
      <DialogActions>
        <Button onClick={props.onCancel} disabled={props.disableButtons}>
          Cancel
        </Button>
        <Button
          onClick={props.onSubmit}
          color="primary"
          disabled={props.disableButtons}
          autoFocus
        >
          {props.submitLabel}
        </Button>
      </DialogActions>
    </Dialog>
  )
}
